module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAqCAYAAADf/ynVAAAAAXNSR0IArs4c6QAAASdJREFUWAntmb0NwkAMhe3jZ4B0SOzACvQpIRV7hBGQsgdCAqVD1KzADkh0GQCkmDNlFMUx4RIKX5f4+fzynaWTHAS/Nmk+fwFlhLAEohm/630hPpDgOgFM99nqjmzqCeXNG4l6N1NfsJiCWzgm9Uem2GrEntzn+OqdD/aWPbnBeqrps32fu6b4kDEzpqVvxIyYloBWbz2mJTaWEnCE8XG3vkg6jifbPAYqz220kkY8SioRpU1CxDFJTxRi4657isS6Fvg234xpyRkxI6YloNVbj2mJ/fSubFu8zZ0qHqXdlRXcIrGKvrdHM6ZFbcSMmJaAVm89pifmp8XapOB678nxCDt4IWUB9uR4ru7zCmVuSHnBnhwP+3mujoAHGPJY+QeE98Be2NMbJ7BGNQ1lExgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/7@2x.png
// module id = c2Ea
// module chunks = 199